import { axios, transformAxiosError } from "../utils/axios.create";
import {
  OrganizationLabel,
  OrganizationLabelPayload,
} from "../domain/organizationLabels.interface";

export type OrganizationLabelsFindAllPayload = {
  sortField: string;
  sortOrder: number;
  pageNumber: number;
  pageSize: number;
  search: string;
  status: string;
};

const findAll = async ({
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
  search,
  status,
}: OrganizationLabelsFindAllPayload): Promise<{
  list: OrganizationLabel[];
  totalCount: number;
}> => {
  const queryParams = new URLSearchParams({
    search,
    status,
    pageNumber: String(pageNumber + 1),
    pageSize: String(pageSize),
    sortField,
    sortOrder: sortOrder === 1 ? "asc" : "desc",
  });

  return axios
    .get(`/organization-labels/search?${queryParams.toString()}`)
    .then((res) => ({
      list: res.data.body.list as OrganizationLabel[],
      totalCount: res.data.body.totalCount as number,
    }))
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const findActive = async (): Promise<OrganizationLabel[]> => {
  const queryParams = new URLSearchParams({ status: "ACTIVE" });
  return axios
    .get(`/organization-labels?${queryParams.toString()}`)
    .then((res) => (res.data.body || []) as OrganizationLabel[])
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const createOne = async (
  payload: OrganizationLabelPayload
): Promise<OrganizationLabel> => {
  return axios
    .post("/organization-labels", payload)
    .then((res) => res.data.body as OrganizationLabel)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const updateOne = async ({
  id,
  payload,
}: {
  id: string;
  payload: OrganizationLabelPayload;
}): Promise<OrganizationLabel> => {
  return axios
    .put(`/organization-labels/${id}`, payload)
    .then((res) => res.data.body as OrganizationLabel)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const archiveOne = async (id: string): Promise<void> => {
  return axios
    .delete(`/organization-labels/${id}`)
    .then(() => undefined)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

export const OrganizationLabelService = {
  findAll,
  findActive,
  createOne,
  updateOne,
  archiveOne,
};
